<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
  >
    <base-header
      :title="$t('app.deportes.name')"
      link="Dashboard"
    />
    <v-row justify="center">
      <v-col
        cols="12"
      >
        <base-material-card color="primary">
          <template v-slot:heading>
            <v-row>
              <v-col class="flex-grow-1 flex-grow-0">
                <div class="display-2 font-weight-light">
                  {{ $t('app.deportes.title') }}
                </div>

                <div class="subtitle-1 font-weight-light">
                  {{ $t('app.deportes.subtitle') }}
                </div>
              </v-col>
              <v-col class="d-flex align-center flex-grow-0 flex-shrink-0">
                <v-btn
                  dark
                  @click="openItemAdd"
                >
                  <v-icon
                    dark
                    left
                  >
                    mdi-plus-circle
                  </v-icon>

                  {{ $t('app.buttons.add') }}
                </v-btn>
              </v-col>
            </v-row>
          </template>

          <v-card-title>
            <v-row>
              <v-col>
                <v-select
                  v-model="filters.selected.items"
                  :items="filters.data.items"
                  item-text="nombre"
                  item-value="id"
                  :label="$t('app.sucursales.name')"
                  multiple
                  chips
                  deletable-chips
                  clearable
                  outlined
                  rounded
                  dense
                />
              </v-col>
              <v-col>
                <v-text-field
                  v-model="filters.selected.query"
                  :label="$t('app.buttons.search')"
                  rounded
                  outlined
                  dense
                  append-icon="mdi-magnify"
                  clearable
                />
              </v-col>
            </v-row>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="filteredItems"
            :items-per-page="10"
            :search="filters.selected.query"
          >
            <template v-slot:item.actions="{ item }">
              <v-col class="d-flex justify-end">
                <v-btn
                  icon
                  @click="openItemDetail(item)"
                >
                  <v-icon>
                    mdi-eye
                  </v-icon>
                </v-btn>

                <v-btn
                  icon
                  @click="openItemEdit(item)"
                >
                  <v-icon>
                    mdi-pencil
                  </v-icon>
                </v-btn>

                <v-btn
                  icon
                  @click="openItemDelete(item)"
                >
                  <v-icon>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </v-col>
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>

    <deportes-add />
    <deportes-edit />
    <deportes-detail />
    <deportes-delete />
  </v-container>
</template>

<script>
  export default {
    name: 'Deportes',
    components: {
      DeportesAdd: () => import('./DeportesAdd'),
      DeportesEdit: () => import('./DeportesEdit'),
      DeportesDetail: () => import('./DeportesDetail'),
      DeportesDelete: () => import('./DeportesDelete'),
    },
    data () {
      return {
        headers: [
          {
            text: this.$t('app.headers.id'),
            value: 'id',
          },
          {
            text: this.$t('app.headers.description'),
            value: 'descripcion',
          },
          {
            text: '',
            value: 'actions',
            sortable: false,
          },
        ],
        items: [],
        filters: {
          data: {
            items: [],
          },
          selected: {
            items: [],
            query: '',
          },
        },
      }
    },
    computed: {
      filteredItems () {
        if (this.filters.selected.items.length > 0) {
          return this.items.filter(item => this.filters.selected.items.includes(item.sucursal_id))
        } else {
          return this.items
        }
      },
    },
    mounted () {
      this.init()

      EventBus.$on('reload-items', () => {
        this.init()
      })
    },
    methods: {
      async init () {
        this.toggleLoader()

        this.filters.data.items = await this.getBranches()
        this.items = await this.getDeportes()

        this.toggleLoader()
      },
      openItemAdd () {
        EventBus.$emit('deportes-add')
      },
      openItemEdit (item) {
        EventBus.$emit('deportes-edit', item)
      },
      openItemDetail (item) {
        EventBus.$emit('deportes-detail', item)
      },
      openItemDelete (item) {
        EventBus.$emit('deportes-delete', item)
      },
    },
  }
</script>

<style scoped>

</style>
